<template>
  <div>
    <div class="ds-relative">
      <AkInput
        v-model.trim="inputValue"
        type="search"
        icon-left="search"
        :placeholder="placeholder"
        size="medium"
        :disabled="disabled"
        class="ds-font-basic ds-rounded-md"
        v-bind="listeners"
        @update:model-value="debounceSearch"
        @focus="handleFocus"
      />

      <button
        v-if="clearBtn && inputValue"
        :class="['ds-absolute ds-inset-y-1 ds-right-3', 'ds-bg-white']"
        @click.stop="clearSearch"
      >
        <AkIcon
          size="sm"
          symbol="x"
        />
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { AkIcon, AkInput } from '@ankorstore/design-system';

export default defineComponent({
  name: 'DebouncedSearch',
  components: {
    AkInput,
    AkIcon,
  },
  props: {
    clearBtn: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    debounce: {
      type: Number,
      required: false,
      default: 600,
    },
    searchTerms: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['input', 'cleared', 'focus'],
  data() {
    return {
      debounceFn: null,
      inputValue: this.searchTerms,
    };
  },
  computed: {
    listeners() {
      const { input, cleared, ...listeners } = this.$attrs;
      return listeners;
    },
  },
  watch: {
    searchTerms(newValue: string): void {
      this.inputValue = newValue;
    },
  },
  methods: {
    clearSearch(): void {
      this.inputValue = '';
      this.notifyInput();
      this.notifyCleared();
    },
    handleFocus(): void {
      this.$emit('focus');
    },
    debounceSearch() {
      clearTimeout(this.debounceFn);
      if (!this.inputValue.length) {
        this.notifyCleared();
      }
      if (this.inputValue.length < 3) {
        return;
      }
      this.debounceFn = setTimeout(() => {
        this.notifyInput();
      }, this.debounce);
    },
    notifyInput() {
      this.$emit('input', this.inputValue);
    },
    notifyCleared() {
      this.$emit('cleared');
    },
  },
});
</script>
